<template>
  <div class="mb-4">
    <v-row align="center" dense>
      <v-col>
        <h2 class="body-1">Ближайшие записи на занятия</h2>
      </v-col>
      <v-col align="right">
        <v-btn text to="lessons" color="accent">Смотреть все</v-btn>
      </v-col>
    </v-row>
    <v-divider class="mb-1"></v-divider>
    <div v-if="!loading && lessons.count===0">
      Нет ближайших записей
    </div>

    <v-progress-linear indeterminate v-if="loading"></v-progress-linear>
    <v-layout column v-if="!loading">
      <v-flex v-for="lesson of lessons" :key="lesson.id" class="mb-2">
        <user-lesson-card :lesson="lesson" :show-date="true"
                          v-on:change="loadLessons"></user-lesson-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import Lesson from '../../api/Lesson';
import UserLessonCard from './UserLessonCard.vue';

export default {
  name: 'UserFutureLessons',
  components: { UserLessonCard },
  data: () => ({
    lessons: [],
    loading: false,
  }),
  computed: {
    currentUserId() {
      return this.currentUser.id;
    },
    ...mapGetters(['currentUser', 'classes', 'UISettings', 'filials']),
  },
  watch: {
    currentUserId() {
      this.loadLessons();
    },
  },
  methods: {
    async loadLessons() {
      if (this.currentUser) {
        this.loading = true;
        const filter = {
          userId: this.currentUser.id,
          scopeUserId: this.currentUser.id,
          date: [moment().format('YYYY-MM-DD'), moment().add(6, 'month').format('YYYY-MM-DD')],
          countFreeRecords: true,
          includeRecords: true,
          includeTasksLimited: true,
          includeMarks: true,
          includeParams: true,
          includeComments: true,
          includeTaskAnswers: true,
          limit: 15,
          sort: 'date',
        };
        const result = await Lesson.fetch(filter);
        this.lessons = result.data.lessons.filter((lesson) => {
          const cl = this.classes.find(c => c.id === lesson.classId);
          if (!cl) {
            return false;
          }
          const filial = this.filials.find(f => f.id === cl.filialId);
          if (!filial) {
            return false;
          }
          const endDate = moment.tz(`${lesson.date} ${lesson.endTime}:00`, filial.timezone);
          if (lesson.endTime < lesson.beginTime) {
            endDate.add(1, 'days');
          }
          const tzNow = moment().tz(filial.timezone);

          return endDate >= tzNow;
        }).splice(0, 3);
        this.loading = false;
      }
    },
  },
  mounted() {
    this.loadLessons();
  },
};
</script>

<style scoped>

</style>
